import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import React from "react";
import Link from "../ui/RouterLink";
import { API_BASE } from "../utils";
import { listArchivedAlbums } from "../api/collection";
import { describeApiError } from "../api/request";
import CollectionActions from "../components/CollectionActions";
import AlbumQuantity from "../components/AlbumQuantity";
import "../styles/collection.css";
export default function ArchivedAlbums({ settings }) {
  const [page, setPage] = React.useState(1);
  const [revision, setRevision] = React.useState(0);
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  const heading = React.useRef(null);
  React.useEffect(() => {
    if (revision > 0) heading.current?.focus();
  }, [revision]);
  React.useEffect(() => {
    const controller = new AbortController();
    setData(null);
    setError(null);
    listArchivedAlbums({
      page,
      signal: controller.signal,
    })
      .then((result) => {
        if (controller.signal.aborted) return;
        const lastPage = Math.max(
          1,
          Math.ceil(result.total / result.page_size),
        );
        if (page > lastPage) setPage(lastPage);
        else setData(result);
      })
      .catch((failure) => {
        if (!controller.signal.aborted) setError(failure);
      });
    return () => controller.abort();
  }, [page, revision]);
  return (
    <section>
      <h2 tabIndex={-1} ref={heading}>
        Archived Releases
      </h2>
      <p>Your saved release and track details are preserved and read-only.</p>
      <Link to="/">View active collection</Link>
      {error ? (
        <Alert role="alert" severity="error">
          {describeApiError(error)}{" "}
          <Button
            className="btn"
            onClick={() => setRevision((value) => value + 1)}
          >
            Retry archived releases
          </Button>
        </Alert>
      ) : !data ? (
        <p role="status">Loading archived releases…</p>
      ) : (
        <>
          {!data.albums.length && <p>No archived releases.</p>}
          <ul className="album-grid">
            {data.albums.map((album) => (
              <li className="album-tile archived-tile" key={album.id}>
                <div className="archived-data">
                  <div className="album-thumb">
                    <img
                      src={`${API_BASE}/albums/${album.id}/image/`}
                      alt={`${album.title} cover`}
                      loading="lazy"
                    />
                  </div>
                  <div className="album-info">
                    <h3>
                      <Link to={`/album/${album.id}?archived=true`}>
                        {album.title}
                      </Link>
                    </h3>
                    <p>
                      {album.artists
                        ?.map((artist) =>
                          typeof artist === "string" ? artist : artist.name,
                        )
                        .join(", ") || album.artist}
                    </p>
                    <AlbumQuantity quantity={album.quantity} />
                  </div>
                </div>
                <CollectionActions
                  album={album}
                  settings={settings}
                  onChanged={() => {
                    setRevision((value) => value + 1);
                  }}
                />
              </li>
            ))}
          </ul>
          {data.total > data.page_size && (
            <nav
              className="collection-actions"
              aria-label="Archived release pages"
            >
              <Button
                className="btn"
                disabled={page === 1}
                onClick={() => setPage((value) => value - 1)}
              >
                Previous
              </Button>
              <span>
                Page {page} of {Math.ceil(data.total / data.page_size)}
              </span>
              <Button
                className="btn"
                disabled={page * data.page_size >= data.total}
                onClick={() => setPage((value) => value + 1)}
              >
                Next
              </Button>
            </nav>
          )}
        </>
      )}
    </section>
  );
}
